<template>
	<v-dialog :fullscreen="isMobile" scrollable attach name="hostHelp" ref="hostHelp" v-model="hostHelp" transition="dialog-top-transition" max-width="700px">
		<v-card raised>
			<v-card-title class="display-1">
				<button type="button" class="btn-flat-icon--dark" @click="setHostHelpOpen(false)">
					<v-icon large>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<div>
					<h3 class="pb-2">
						Need help?
					</h3>
					<p>Thats what we're here for.</p>
					<p>Please don't hesitate to contact us for assistance or questions.
					<p><a>support@wrkprty.com</a></p>
					<p><a href="tel:209-975-7789"><i class="fa fa-phone"></i>&nbsp;(209) 975-7789</a></p>
				</div>
				<div v-if="!isMobile">
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'hostHelpModal',
	data() {
		return {
			name: '',
			email: '',
			phone: '',
			city: '',
			message: '',
			nameRules: [
				v => !!v || 'Name is required',
				v => v.length <= 20 || 'Name must be less than 20 characters'
			],
			emailRules: [
				v => !!v || 'E-mail is required',
				v =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
					'E-mail must be valid'
			],
			phoneRules: [
				v =>
					/(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
					'Please enter a valid phone number'
			],
			cityRules: [v => v.length <= 20 || 'City must be less than 20 characters']
		}
	},
	created() {
		this.name = this.user.first_name + ' ' + this.user.last_name
		this.email = this.user.email
		this.phone = this.getHostApplyInfo('phone')
	},
	methods: {
		...mapActions(['setHostHelpOpen', 'setSnackbarOpen', 'setSnackbarText']),
		sendHostHelp() {
			axios
				.post('/api/v1/contact/', {
					name: this.name,
					message: 'Host Help Request: \n' + this.message,
					email: this.email,
					phone: this.phone,
					city: this.city
				})
				.then(response => {
					this.setHostHelpOpen(false)
					setSnackbarOpen(true)
					setSnackbarText('Message Sent!')
				})
		}
	},
	computed: {
		...mapGetters(['user', 'getHostApplyInfo', 'getHostHelpOpen']),
		hostHelp: {
			get() {
				return this.getHostHelpOpen
			},
			set(val) {
				this.setHostHelpOpen(val)
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
